import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StyleSheet, View } from './components/base_components';

import { BusyOverlay, useBusy } from './components/busy_component';
import StandardBoxList from './components/standard_box_list';
import TextButton from './components/buttons/text_button';
import TitleActionLine from './components/title_action_line';
import BoxPropList from './components/box_prop_list';

import OrgStore from './stores/org_store';
import UserStore from './stores/user_store';

const styles = StyleSheet.create({
  accountScreen: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  actionButton: { marginLeft: '1rem' },
});

export default function AccountScreen() {
  const [is_busy, setBusy, clearBusy] = useBusy();
  const current_org = UserStore.useOrg();
  const user = UserStore.useUser();
  const [updates, setUpdates] = React.useState<any>({});
  const navigate = useNavigate();
  const [selected, setSelected] = React.useState([]);

  const selected_org = user?.org_list?.[selected[0]];

  function _onLeavePress() {
    if (selected_org?.is_admin) {
      window.alert("Sorry, you can't leave an org if you're an admin.");
    } else {
      const msg = `Are you sure you want to leave ${selected_org.org_name}?`;
      const yes = window.confirm(msg);
      if (yes && setBusy()) {
        OrgStore.leaveOrg({ org_id: selected_org.org_id }, (err) => {
          if (err) {
            window.alert('Leave org failed, please try again.');
          } else {
            window.alert('Org left!');
          }
          clearBusy();
        });
      }
    }
  }
  function _onSwitchPress() {
    UserStore.setCurrentOrgId(selected_org?.org_id);
  }

  function _onSave(complete) {
    const { user_name } = updates;
    if (user_name && setBusy()) {
      UserStore.updateUser(updates, (err) => {
        clearBusy();
        if (err === 409) {
          window.alert('Username already in use.');
        } else if (err === 400) {
          window.alert(
            'Invalid username, please only use letters, numbers, dash and underscore.  Usernames must be between 4 and 32 characters.'
          );
        } else if (err) {
          window.alert('Save failed, please try again.');
        } else {
          complete();
        }
      });
    }
  }
  function _onLogoutPress() {
    const yes = window.confirm('Are you sure you want to logout?');
    if (yes && setBusy()) {
      UserStore.logout(() => {
        navigate('/');
        clearBusy();
      });
    }
  }
  const buttons = (
    <>
      <TextButton
        style={styles.actionButton}
        text='Switch To Org'
        disabled={!selected_org || selected_org?.org_id === current_org.org_id}
        onPress={_onSwitchPress}
      />
      <TextButton
        style={styles.actionButton}
        text='Leave Org'
        type='danger'
        disabled={!selected_org}
        onPress={_onLeavePress}
      />
    </>
  );
  const rows = user?.org_list?.map?.((org) => {
    const active = org.org_id === current_org.org_id ? ' (Active)' : '';
    return [`${org.org_name}${active}`, org.is_admin ? 'Admin' : 'Member'];
  });

  return (
    <View style={styles.accountScreen}>
      <TitleActionLine title='Account'>
        <TextButton text='Sign out' onPress={_onLogoutPress} />
      </TitleActionLine>
      <BoxPropList
        title='Your User'
        editable={true}
        updates={updates}
        onChange={setUpdates}
        onSave={_onSave}
        columns={[
          [
            {
              key: 'user_name',
              label: 'User Name',
              value: user?.user_name,
              emptyValue: '-',
              input: { placeholder: 'user name' },
            },
            { label: 'Email Address', value: user?.email },
          ],
        ]}
      />
      <StandardBoxList
        title='Your Organizations'
        headers={['Name', 'Role']}
        buttons={buttons}
        rows={rows}
        selected={selected}
        onChange={setSelected}
        singleSelect={true}
      />
      <BusyOverlay isBusy={is_busy} />
    </View>
  );
}
